import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import UserForm from './UserForm';
import LoadingView from '../shared/LoadingView';
import DeleteButton from '../shared/DeleteButton';
import RestrictPath from '../shared/user/RestrictPath';
import { fetchSelectAction } from '../store/resources';

class UserFormPageView extends Component {
  componentDidMount() {
    if (this.props.match.params.userId) {
      this.props.fetchSelect('users', this.props.match.params.userId);
    }
  }

  render() {
    const userId = this.props.match.params.userId;
    const update = userId ? this.props.user : null;
    if (userId && update === null) {
      return <LoadingView />;
    }

    const title = update ? `Gebruiker wijzigen` : 'Gebruiker toevoegen';
    return (
      <Fragment>
        <nav className="navbar navbar-expand navbar-light bg-light">
          <div className="navbar-brand">{title}</div>
          {update && (
            <RestrictPath path="users/" methods="DELETE">
              <DeleteButton
                path={`users/${update.uuid}`}
                returnPath="/users/"
                className="ml-auto"
              />
            </RestrictPath>
          )}
        </nav>
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
              <div className="card">
                <div className="card-body">
                  <UserForm update={update} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.users.selected
});

const mapDispatchToProps = (dispatch) => ({
  fetchSelect: (resourceName, id) => dispatch(fetchSelectAction(resourceName, id))
});

export default connect(mapStateToProps, mapDispatchToProps)(UserFormPageView);
